import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AbstractControl } from '@angular/forms';
import { Field } from '@app/interfaces';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { QuillModules } from "ngx-quill/config";

@Component({
  selector: 'app-form-input-rich-text',
  templateUrl: './form-input-rich-text.component.html',
  styleUrls: ['./form-input-rich-text.component.scss'],
  standalone: false
})
export class FormInputRichTextComponent {
  @Input() control: AbstractControl;
  @Input() field: Field<string>;

  public quillConfiguration: QuillModules = {
    clipboard: {
      matchVisual: false
    },
    tabIndex: 0,
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['clean'],
      ['link', 'image']
    ]
  };

  private destroy$ = new Subject<void>();

  constructor(
    private cdr: ChangeDetectorRef,
    private el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const element = this.el.nativeElement.querySelector('.ql-editor');
      if (element) {
        element.setAttribute('tabindex', '0');
      }

      // NOTE: we deliberately do NOT override Quill's default block blot.
      // A previous version set `Block.tagName = 'div'` and re-registered it on
      // Quill's GLOBAL registry (BRIEFD-3377). That mutated the shared Quill
      // singleton, leaked to every other Quill editor in the app, and corrupted
      // their caret (typing jumped to the start / spaces dropped). No consumer
      // depends on the block being <div> vs <p> — all description render paths
      // dump raw HTML or strip tags tag-agnostically — so we keep Quill's stock
      // <p> block for every editor (BRIEFD-6766).

      if (this.field.config.quillConfiguration) {
        this.quillConfiguration = this.field.config.quillConfiguration;
      }

      this.control.statusChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.cdr.detectChanges());
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
